import { useEffect, useState } from 'react';

/**
 * V2 Device Type Hook - Aligned with Tailwind CSS breakpoints
 *
 * This version uses max-width: 767px to match Tailwind's `md:` breakpoint (768px).
 * This ensures consistency between JS logic and CSS responsive classes.
 *
 * Tailwind breakpoints for reference:
 * - sm: 640px
 * - md: 768px ← This version aligns with md
 * - lg: 1024px
 * - xl: 1280px
 * - 2xl: 1536px
 *
 * @deprecated V1 (deviceType.ts) uses max-width: 1023px which doesn't align with standard breakpoints.
 * Gradually migrate to this version to avoid breaking existing UI layouts.
 * Once migration is complete, V1 can be removed.
 */

const getDeviceType = () => {
  // Matches Tailwind's md breakpoint (768px)
  // Returns true for mobile/tablet (< 768px), false for desktop (>= 768px)
  return window.matchMedia('(max-width: 767px)').matches;
};

export const useDeviceTypeV2 = () => {
  const [isMobile, setIsMobile] = useState(getDeviceType());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getDeviceType());
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return isMobile;
};
